import React from 'react'
import Layout from "../../components/layout"
import { Link } from "gatsby"
import Footer from '../../components/footer'
import BgImage from '../../images/bg/solutions-page-banner.jpg'
import SocialIconsFooter from '../../components/social-icons-footer'
import { StaticImage } from 'gatsby-plugin-image'

const WebsiteDeliveryScope = () => {
    return (
        <Layout pageTitle="PragICTS | ITOPS | Services | ITIL - ITSL" og_desc="">
            <div id="wrapper" className="single-page-wrap">
                <div className="content">
                    <div className="single-page-decor"></div>
                    <div className="single-page-fixed-row">
                        <div className="scroll-down-wrap">
                            <div className="mousey">
                                <div className="scroller"></div>
                            </div>
                            <span>Scroll Down</span>
                        </div>
                        <Link to="/" className="single-page-fixed-row-link"><i className="fal fa-arrow-left"></i> <span>Back to home</span></Link>
                    </div>

                    <section className="parallax-section dark-bg sec-half parallax-sec-half-right" data-scrollax-parent="true">
                        <div className="bg par-elem"  data-bg={BgImage} data-scrollax="properties: { translateY: '30%' }"></div>
                        <div className="overlay"></div>
                        <div className="pattern-bg"></div>
                        <div className="container">
                            <div className="section-title">
                                <h2> ITIL - 
<span> ITSL</span></h2>
                                <p></p>
                            
                            </div>
                            <a href="#sec1" className="custom-scroll-link hero-start-link"><span>Let's Start</span> <i className="fal fa-long-arrow-down"></i></a>
                        </div>
                    </section>
                    <section data-scrollax-parent="true" id="sec1">
                        <div className="section-subtitle left-pos"  data-scrollax="properties: { translateY: '-250px' }" ><span></span></div>
                        <div className="container main-about">
                          


                            
                        
                            
                        




  <p>
    <h3 style={{fontSize: '15px', fontWeight: 'bold', color: 'black'}}>Context</h3>
    <p style={{fontSize: '13px'}}>
    IT plays an essential part in modern life and business, whether used directly or in a supporting function (such as offering customer service via email and instant messaging). In fact, IT is so integrated into day-to-day life, it is easy to forget just how much we rely on technology – that is, until something stops working.<br/><br/>
    
    For IT services to be offered reliably and affordably, they must achieve their intended purposes while using an appropriate amount of resources. To accomplish and maintain this, IT professionals and their organisations need to take an orderly, structured approach. This includes documenting processes and regularly reviewing them rather than relying on proprietary knowledge, which often goes unchallenged and is too dependent on specific members of staff.<br/><br/>

    IT service management (ITSM) frameworks offer a structured approach that helps IT professionals focus on what their technology is trying to achieve, rather than just on getting the technology itself to work. This kind of outcome-based approach means that you should think about what stakeholders, especially customers, are asking for and how you can meet their expectations.<br/><br/>

    You could conclude, for example, that you should replace certain software because a cheaper or more efficient alternative is available. You may even find that some software is no longer needed and can be removed altogether. In short, ITSM is designed to speed things up and make life easier. An effective ITSM framework can also fit within a larger system or framework that answers to the organisation more broadly, making it subject to general principles or practices like governance and continual improvement. Particularly in today’s fast-paced world, it is important to regularly revisit customer expectations and review your products and services to ensure they can still meet those expectations to ultimately deliver value – a fundamental concept in ITSM.<br/>
    </p>
  </p>

  <p>
    <h3 style={{fontSize: '15px', fontWeight: 'bold', color: 'black'}}>Why Choose ITIL</h3>
    <h6 style={{fontSize: '13px'}}>
        ITIL, now at version 4, offers a widely accepted and effective ITSM framework. It has anumber of benefits:
      <ul>
        <li>1. ITIL is considered best practice, as it was developed based on practitioners’ real experiences, and has been successfully adopted by many professionals and organisations around the world.</li><br/>
        <li>2. The framework is vendor-neutral, making it suitable for organisations of any size and industry.</li><br/>
        <li>3. ITIL is non-prescriptive – rather than stipulating requirements, it contains best-practice processes, principles, and practices that organisations can adopt and adapt as necessary to meet their requirements.</li><br/>
        <li>4. ITIL offers an internationally recognised certification scheme for practitioners (discussed in more detail in Certification). In line with that, exams are available in a range of languages.</li><br/>
        <li>5. ITIL is a ‘living’ framework, with its latest iteration published in 2019 (and higher- level exams launched in 2020), so you can be sure that the ITSM practices you
are adopting are up to date.</li><br/>
      </ul>
      More concretely, adopting ITIL’s practices might help you prioritise more effectively by, for example, distinguishing incidents from problems or service requests. Alternatively, it can help you offer self-service options to ease the burden on IT staff and lower service desk costs. Adopting the framework could also help align IT goals with business requirements, such as requiring 99.9% website availability. Because the framework is flexible, you can use ITIL for everything from making a particular IT function more efficient to applying it across the full product and service development process. It is also possible to take a phased approach to implementation, giving you and your organisation a chance to try out ITIL before investing any further.
    </h6>
  </p>

  <p>
    <h3 style={{fontSize: '15px', fontWeight: 'bold', color: 'black'}}>ITIL and ITSM</h3>
    <h6 style={{fontSize: '13px'}}>
      ITIL is a framework that provides guidelines and best practices for IT Service Management (ITSM), which is the broader practice of managing IT services to meet business needs. <br/><br/>
      ITIL helps organizations standardize and improve their IT service delivery, aligning IT with business goals and improving customer satisfaction.<br/><br/>
      There are 03  categories of ITIL 4 Management Practices
    
    <ul>
        <li>1. General Management Practices<br/>These apply across the organisation for the success of the business and the services it provides.</li><br/>
        <li>2. Service Management Practices<br/>These apply to specific services that are being developed, deployed, delivered, and supported.</li><br/>
        <li>3. Technical Management Practices<br/>These are adapted from technology management domains for service management purposes.</li><br/>
       
      </ul>
</h6>
  </p>

  <p>
  <h3 style={{fontSize: '15px',fontWeight: 'bold', color: 'black'}}>The Four Dimensions of Service Management</h3>
  <p style={{fontSize: '13px'}}>
    The four dimensions model wants organisations to consider the following:<br/><br/>

    <b>01 Organisations and People</b><br/>
    Clearly define organisational structure, roles, responsibilities, hierarchies and communication systems, and make sure these align to the overall strategy and operating model.<br/><br/>

    <b>02 Information and Technology</b><br/>
    What information, knowledge and technologies are required to manage the products/services effectively, and how information is exchanged between activities and services.<br/><br/>

    <b>03 Partners and Suppliers</b><br/>
    What relationships, agreements and contracts you have with third parties with respect to developing or delivering your products/services, and to what extent
    you rely on those third parties.<br/><br/>

    <b>04 Value Streams and Processes</b><br/>
    Ensure all activities in all parts of the organisation are effectively integrated, organised and coordinated to enable value creation through your products/services for all stakeholders.<br/><br/>

    Note that the four dimensions do not have hard borders and may overlap.
  </p>
</p>

<p>
  <h3 style={{fontSize: '15px',fontWeight: 'bold', color: 'black'}}>TOTAL PRACTICES</h3>
  <p style={{fontSize: '13px'}}>
    14 - General Management Practices<br/>
    17 - Service Management Practices<br/>
    03 - Technical Management Practices<br/>
    _______________________________<br/>
    34 - Total Practices
  </p>
</p>

<p>
  <h3 style={{fontSize: '15px',fontWeight: 'bold', color: 'black'}}>01 GENERAL MANAGEMENT PRACTICES</h3>
  <p style={{fontSize: '13px'}}>
    This section contains 14 management practices:<br/><br/>

    <b>01 Architecture Management</b><br/>
    This practice helps organisations manage the often complex way in which their organisational architecture relates to various parts of the business.<br/>
    It provides the principles, standards, and tools to help manage changes in a structured and agile way.<br/><br/>

    <b>02 Continual Improvement</b><br/>
    Organisations must be able to align their processes and services with changing business needs.<br/>
    The continual improvement practice helps them achieve this.<br/>
    It ensures that organisations identify opportunities for improvement within services, service components, practices, or other parts of service management.<br/><br/>

    <b>03 Information Security Management</b><br/>
    This practice relates to the way an organisation protects its sensitive information from misuse.<br/>
    Specifically, information security management looks at ways to prevent breaches of the confidentiality, integrity, and availability of data.<br/>
    In this context, confidentiality refers to information being viewed only by authorised parties, integrity to information being accurate, and availability to information being accessible when necessary.<br/><br/>

    <b>04 Knowledge Management</b><br/>
    This practice helps organisations improve the way that they use data. It focuses on the convenience, effectiveness, and efficiency of knowledge and data use.<br/><br/>

    <b>05 Measurement and Reporting</b><br/>
    To make good decisions and continually improve systems, organisations must conduct evidence-based research.<br/>
    This practice provides a framework for doing that, recommending risk assessments and the collection of relevant data.<br/><br/>

    <b>06 Organisational Change Management</b><br/>
    This practice helps organisations implement the changes recommended during the continual improvement process.<br/>
    It emphasises the human aspect of change management and the lasting benefits that can be had if the challenges and opportunities of individuals are accounted for.<br/><br/>

    <b>07 Portfolio Management</b><br/>
    This practice ensures that the organisation has the right combination of programs, products, and services to achieve its goals.<br/>
    It also accounts for the organisation’s funding and resource constraints.<br/><br/>

    <b>08 Project Management</b><br/>
    This practice helps organisations oversee their ongoing projects and ensure that they are delivered successfully.<br/>
    It addresses the way projects are planned, delegated, monitored, and maintained. It also addresses the relationships between stakeholders and aims to keep those involved in the project motivated.<br/><br/>

    <b>09 Relationship Management</b><br/>
    For projects to be successful, organisations must establish and nurture the relationships between stakeholders.<br/>
    This practice is done by helping organisations identify, analyse, monitor, and continually improve relationships.<br/><br/>

    <b>10 Risk Management</b><br/>
    This practice helps organisations understand and address risks.<br/>
    There are countless ways that problems could materialise, and it’s essential that they are spotted as soon as possible to prevent disruption, financial consequences, and sustainability issues.<br/><br/>

    <b>11 Service Financial Management</b><br/>
    This practice supports the organisation’s strategies and plans by ensuring that financial resources and investments are used efficiently.<br/><br/>

    <b>12 Strategy Management</b><br/>
    This practice helps organisations define specific goals and ways to achieve them.<br/>
    It also ensures that necessary resources are allocated to meet those goals and clarifies the organisation’s priorities.<br/><br/>

    <b>13 Supplier Management</b><br/>
    Organisations must manage their suppliers effectively if they are to ensure the smooth production and delivery of products and services.<br/>
    This practice helps foster those relationships, focusing on creating opportunities for collaboration and identifying ways to make improvements.<br/><br/>

    <b>14 Workforce Talent Management</b><br/>
    This practice helps organisations put talented and skilled people in the right roles.<br/>
    It focuses on the planning, recruiting, onboarding and training of employees.<br/>
    It also looks at the way organisations evaluate the performance of employees and how to develop succession planning.<br/>
  </p>
</p>

<p>
  <h3 style={{fontSize: '15px',fontWeight: 'bold', color: 'black'}}>02 SERVICE MANAGEMENT PRACTICES</h3>
  <p style={{fontSize: '13px'}}>
    This section contains a further 17 management practices:<br/><br/>

    <b>01 Availability Management</b><br/>
    With this practice, organisations can ensure that the availability of products and services meets the customer’s needs.<br/>
    Those needs should have been agreed upon at the outset of the project.<br/><br/>

    <b>02 Business Analysis</b><br/>
    This practice helps organisations analyse their business processes or elements within them.<br/>
    It’s intended to help solve specific issues and improve value creation for stakeholders.<br/><br/>

    <b>03 Capacity and Performance Management</b><br/>
    This practice helps organisations ensure that their products and services meet expected performance levels.<br/>
    It also addresses current and future demands, helping organisations identify any changes that could affect their capacity.<br/><br/>

    <b>04 Change Enablement</b><br/>
    This practice ensures that organisations maximise successful IT changes.<br/>
    It does so by ensuring that risk assessments are conducted, that proper authorisations are in place for implementing change and that changes are managed efficiently.<br/><br/>

    <b>05 Incident Management</b><br/>
    The objective of this practice is to mitigate the negative impact of disruptive incidents. It helps organisations identify ways of restoring normal service operation as quickly as possible.<br/><br/>

    <b>06 IT Asset Management</b><br/>
    This practice helps organisations manage the complete lifecycle of their IT assets.<br/>
    It’s based on value maximisation, cost control, risk management, decision making, asset reuse management and retirement.<br/>
    It also addresses the regulatory and contractual requirements related to IT assets.<br/><br/>

    <b>07 Monitoring and Event Management</b><br/>
    With this practice, organisations can systematically observe services and service components, and record and report selected changes.<br/>
    They can do this by identifying and prioritising infrastructure, services, business processes, and information security events.<br/>
    The practice also establishes the responses to these events.<br/><br/>

    <b>08 Problem Management</b><br/>
    This practice helps organisations mitigate the impact and likelihood of disruptive events.<br/>
    It does so by focusing on the identification of potential causes of incidents and the ways to navigate them.<br/><br/>

    <b>09 Release Management</b><br/>
    This practice focuses on the way services are deployed. It addresses both new and changed services and features.<br/><br/>

    <b>10 Service Catalogue Management</b><br/>
    This practice ensures that organisations have a single source of consistent information for all their services.<br/>
    It guarantees that information is available for relevant audiences whenever it is required.<br/><br/>

    <b>11 Service Configuration Management</b><br/>
    This practice ensures that information about the configuration of an organisation’s services remains available and accurate.<br/>
    It also addresses the configuration items that support those services.<br/><br/>

    <b>12 Service Continuity Management</b><br/>
    This practice provides a framework for building organisational resilience.<br/>
    It helps organisations protect services in the event of a disruptive incident and ensure that their availability and performance remain at a sufficient level.<br/><br/>

    <b>13 Service Design</b><br/>
    This practice helps organisations design products and services that are fit for use and in line with their defined purpose.<br/>
    It also ensures that services can be successfully delivered by the organisation in its current ecosystem.<br/>
    The practice focuses on product and service planning, as well as the management of people, partners, suppliers, information, communication networks and technology.<br/><br/>

    <b>14 Service Desk</b><br/>
    This practice helps organisations capture demand for incident resolution and service requests. It should also be the contact point for the service provider and its users.<br/><br/>

    <b>15 Service Level Management</b><br/>
    This practice sets business targets for the performance of services. It ensures that service delivery can be properly assessed, enabling the organisation to identify issues and improve its practices.<br/><br/>

    <b>16 Service Request Management</b><br/>
    With this practice, organisations can support the agreed quality of service by handling all pre-defined, user-initiated service requests in an effective and user-friendly manner.<br/><br/>

    <b>17 Service validation and testing</b><br/>
    This practice ensures that new or changed products and services meet their defined requirements.<br/>
    Organisations should do this by measuring service value based on input from customers, business objectives and regulatory requirements.<br/>
  </p>
</p>

<p>
  <h3 style={{fontSize: '15px',fontWeight: 'bold', color: 'black'}}>03 TECHNICAL MANAGEMENT PRACTICES</h3>
  <p style={{fontSize: '13px'}}>
    This section contains the final three management practices:<br/><br/>

    <b>01 Deployment Management</b><br/>
    Deployment management practices help organisations move new or changed hardware, software, documentation and processes from a production to a live environment.<br/>
    It also helps them move those components to other environments for testing or staging.<br/><br/>

    <b>02 Infrastructure and Platform Management</b><br/>
    This practice helps organisations oversee their infrastructure and platforms, enabling them to monitor technologies that are deployed internally and by service providers.<br/><br/>

    <b>03 Software Development and Management</b><br/>
    This practice ensures that applications meet the needs of stakeholders. It addresses software functionality, reliability, maintenance, compliance and their ability to be audited.<br/>
  </p>
</p>

<p>
  <h3 style={{fontSize: '15px',fontWeight: 'bold', color: 'black'}}>Implementation Guidelines</h3>
  <p style={{fontSize: '13px'}}>
    ITIL’s seven guiding principles (approaches or philosophies) are aligned to several popular methodologies, including Agile and DevOps. The seven principles are:<br/><br/>

    <b>01 Focus On Value</b><br/>
    Everything the organisation does should ultimately lead to value for stakeholders.<br/><br/>

    <b>02 Start Where You Are</b><br/>
    Consider what is already available before you build something from scratch.<br/><br/>

    <b>03 Progress Iteratively With Feedback</b><br/>
    Organise work into smaller, manageable efforts, and request feedback before, during, and after each iteration.<br/><br/>

    <b>04 Collaborate and Promote Visibility</b><br/>
    Work together across boundaries and share information as much as possible.<br/><br/>

    <b>05 Think and work holistically</b><br/>
    Because services must work as a whole, not as the individual parts they are made up of, all relevant technologies, people, practices, etc. must be coordinated and integrated.<br/><br/>

    <b>06 Keep it simple and practical</b><br/>
    Eliminate processes, services, etc. that fail to deliver value (or provide another useful outcome), and reduce the number of steps or components if possible.<br/><br/>

    <b>07 Optimise and automate</b><br/>
    Use technology where possible; only have human intervention where it truly provides value.<br/>
  </p>
</p>

<p>
  <h3 style={{fontSize: '15px',fontWeight: 'bold', color: 'black'}}>The Continual Improvement Model</h3>
  <p style={{fontSize: '13px'}}>
    ITIL’s continual improvement model is a high-level, seven-step cycle designed to help you establish your current and target positions, how you will achieve your target, and how to embed successful changes (or learn from failed initiatives).<br/><br/>

    The continual improvement model has seven steps that form a cycle (depicted in Figure 6):<br/><br/>

    <b>01 Define The Initiative’s Vision</b><br/>
    This will help with subsequent decisions and link actions to the organisation’s overall goals and objectives.<br/><br/>

    <b>02 Understand Your Starting Point</b><br/>
    In order to track and understand your improvement, you need to know where you started from. Assess the current state of your products/services from various aspects (e.g. perception of value received, competencies, procedures, etc.), preferably through objective measurement that can also be used in step 6.<br/><br/>

    <b>03 Outline What Your Destination Should Look Like</b><br/>
    It is also important to define your target. Remember that your target does not need to fully realise your vision, just progress towards it, and that it is aspirational. In other words, remember that the goal is to improve, not to achieve perfection.<br/><br/>

    <b>04 Plan The Journey</b><br/>
    If the destination requires only a small change from the starting point, the journey should be direct and straightforward. If more complex changes are necessary, it may be worth breaking up the work into smaller efforts and evaluating progress, with a possible change of direction, after each iteration (in line with the third guiding principle, ‘progress iteratively with feedback’).<br/><br/>

    <b>05 Execute The Plan</b><br/>
    Take the planned action, but remember to keep an open mind – particularly if the work is broken up into smaller efforts, you may need to change direction to reach the intended destination.<br/><br/>

    <b>06 Check That You Have Reached Your Desired Destination</b><br/>
    Check and confirm what progress has been made (ideally with the same objective measurement mechanism you used in step 2), and that what you have achieved still has value (after all, factors such as customer expectations may change). If one or both are not the case, you may need to take additional action to achieve your destination and create value.<br/><br/>

    <b>07 Embed the Changes In The Organisation</b><br/>
    To keep the momentum going, and prevent any improvements from being reversed, promote your successes and reinforce any new methods. Should the initiative have failed, analyse what went wrong, and document and communicate the lessons learned, thereby improving the chances of the next iteration’s success.<br/><br/>

    Step 7 feeds back to step 1, restarting the cycle. Note that the model is flexible – organisations are not expected to rigorously follow these steps, but adjust them in line with their culture and goals. As long as your approach increases your improvement initiatives’ chances of success, you are on the right track.<br/><br/>

  
  </p>
</p>
<p>
<h3 style={{fontSize: '15px',fontWeight: 'bold', color: 'black'}}>ITIL Capability Assessment Levels</h3>
<p style={{fontSize: '13px'}}>
  The ITIL maturity model defines the following capability levels applicable to any management practice:<br/><br/>

  <b>Level 1</b><br/>
  The practice is not well organized; it’s performed as initial or intuitive. It may occasionally or partially achieve its purpose through an incomplete set of activities.<br/><br/>

  <b>Level 2</b><br/>
  The practice systematically achieves its purpose through a basic set of activities supported by specialized resources.<br/><br/>

  <b>Level 3</b><br/>
  The practice is well-defined and achieves its purpose in an organized way, using dedicated resources and relying on inputs from other practices that are integrated into a service management system.<br/><br/>

  <b>Level 4</b><br/>
  The practice achieves its purpose in a highly organized way, and its performance is continually measured and assessed in the context of the service management system.<br/><br/>

  <b>Level 5</b><br/>
  The practice is continually improving organizational capabilities associated with its purpose.<br/><br/>

  For each practice, the ITIL maturity model defines criteria for every capability level from level 2 to level 5. These criteria can be used to assess the practice’s ability to fulfil its purpose and to contribute to the organization’s service value system.<br/><br/>

  Each criterion is mapped to one of the four dimensions of service management and to the supported capability level. The higher the capability level, the more comprehensive realization of the practice is expected. For example, criteria related to practice automation are typically defined at levels 3 or higher because effective automation is only possible if the practice is well-defined and organized.<br/><br/>
</p>

</p>

















                        </div>
                     
                        <div className="bg-parallax-module" data-position-top="50"  data-position-left="20" data-scrollax="properties: { translateY: '-250px' }"></div>
                        <div className="bg-parallax-module" data-position-top="40"  data-position-left="70" data-scrollax="properties: { translateY: '150px' }"></div>
                        <div className="bg-parallax-module" data-position-top="80"  data-position-left="80" data-scrollax="properties: { translateY: '350px' }"></div>
                        <div className="bg-parallax-module" data-position-top="95"  data-position-left="40" data-scrollax="properties: { translateY: '-550px' }"></div>
                        <div className="sec-lines"></div>
                    </section>
                        
                    <SocialIconsFooter />
                </div>
                <Footer />
            </div>
        </Layout>
    )
}

export default WebsiteDeliveryScope
